var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { Component } from "react";
import { CompanyValuesSelect } from "@irati-web/fields/companyValues";
import { Message as MessageField, Share } from "@irati-web/fields/reward";
import { injectIntl } from "@irati/utils/lang";
import authentication from "@irati/auth";
import { isShareableWithTeams } from "@irati/reward/utils/isShareableWithTeams";
import getSharingOptions from "@irati/reward/constants/share";
import OccasionsSelect from "@irati-web/fields/occasions/OccasionsSelect";
import rewardWalletTracking from "@irati-tracking/wallet/rewardWallet";
import { InputWrapper } from "./styled";
var Message = /** @class */ (function (_super) {
    __extends(Message, _super);
    function Message() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            clickEventTracked: false,
            shareEventTracked: false
        };
        _this.handleMessageChange = function (value) {
            var _a = __assign({}, _this.props), messageDetails = _a.messageDetails, setMessageDetails = _a.setMessageDetails;
            messageDetails.message = value;
            setMessageDetails(messageDetails);
        };
        _this.handleShareWithChange = function (value) {
            var _a = __assign({}, _this.props), messageDetails = _a.messageDetails, setMessageDetails = _a.setMessageDetails, isCredit = _a.isCredit;
            messageDetails.sharingPreferences = value;
            setMessageDetails(messageDetails);
            if (isCredit) {
                rewardWalletTracking.selectPermission();
            }
        };
        _this.handleCompanyValuesChange = function (item, property, values) {
            var _a = __assign({}, _this.props), messageDetails = _a.messageDetails, setMessageDetails = _a.setMessageDetails, isCredit = _a.isCredit;
            if (isCredit && values.length > messageDetails.companyValues.length) {
                rewardWalletTracking.selectCompanyValue();
            }
            messageDetails.companyValues = values;
            setMessageDetails(messageDetails);
        };
        _this.handleCompanyValuesSelectClick = function () {
            if (_this.props.isCredit && !_this.state.clickEventTracked) {
                rewardWalletTracking.clickCompanyValueDropdown();
                _this.setState({ clickEventTracked: true });
            }
        };
        _this.handleSharePermissionsClick = function () {
            if (_this.props.isCredit && !_this.state.shareEventTracked) {
                rewardWalletTracking.clickSharePermissions();
                _this.setState({ shareEventTracked: true });
            }
        };
        return _this;
    }
    Message.prototype.getOptions = function () {
        var _a = this.props, intl = _a.intl, recipients = _a.recipients;
        var user = authentication.user();
        var canShareWithEveryone = !!authentication.apps("recognition.recognition.everyone");
        var canBeSharedWithTeams = isShareableWithTeams(user, recipients);
        return getSharingOptions(intl, canShareWithEveryone, canBeSharedWithTeams);
    };
    Message.prototype.render = function () {
        var _a = this.props, formatMessage = _a.formatMessage, messageDetails = _a.messageDetails, selectedOccasion = _a.selectedOccasion, setOccasion = _a.setOccasion;
        var message = messageDetails.message, companyValues = messageDetails.companyValues, sharingPreferences = messageDetails.sharingPreferences;
        return (React.createElement(React.Fragment, null,
            React.createElement(InputWrapper, null,
                React.createElement(MessageField, { label: formatMessage({ id: "reward.message.field.label" }), message: message, onChange: this.handleMessageChange, placeholder: formatMessage({ id: "reward.message.field.placeholder" }) })),
            React.createElement(InputWrapper, null,
                React.createElement(OccasionsSelect, { selectedOption: selectedOccasion, onChange: setOccasion })),
            React.createElement(InputWrapper, { onClick: this.handleCompanyValuesSelectClick },
                React.createElement(CompanyValuesSelect, { item: messageDetails, onChange: this.handleCompanyValuesChange, selectedCompanyValues: companyValues })),
            React.createElement(InputWrapper, { onClick: this.handleSharePermissionsClick },
                React.createElement(Share, { onChange: this.handleShareWithChange, options: this.getOptions(), shareWith: sharingPreferences }))));
    };
    return Message;
}(Component));
export default injectIntl(Message);
